<script>
export default {
  name: 'Actions',
}
</script>

<template>
  <div
    class="tw-flex tw-flex-col lg:tw-flex-row lg:tw-justify-end lg:tw-space-x-5 tw-space-y-5 lg:tw-space-y-0">
    <slot />
  </div>
</template>
